import { SegmentedButtonStringProps, SegmentedButtonIconProps } from '../types';

export const getSegmentContent = (
  segment: SegmentedButtonStringProps | Readonly<SegmentedButtonIconProps>
) => (typeof segment === 'string' || 'icon' in segment ? segment : segment.text);

export const isSegmentDisabled = (value: SegmentedButtonStringProps | SegmentedButtonIconProps) =>
  typeof value !== 'string' && value.disabled;
